import { apiUrl } from '../../apiBase';

// Which picture a 3D run was made from, and where its bytes live.
//
// Shared by both model pages and by the run history, because a run's thumbnail has to
// resolve whatever it was made from — including sources a model no longer accepts.
// Schematics are the case in point: no new run can use one, and the runs that did are
// still in the list and still show their input.

// The three pictures the database holds, and the table each lives in server-side:
//   photo     a part's real photograph (notice_catalog_images)
//   schematic a manual's line drawing of a part (notice_catalog_schematics)
//   listing   a finished-product photo from a listing (notice_listing_images)
export type PictureSource = 'photo' | 'schematic' | 'listing';

export type PictureRef = { source: PictureSource; imageId: number };

// apiUrl, because these are <img src> and not requests: axios carries the build's
// base path for everything that goes through it, and nothing goes through it here.
const SRC: Record<PictureSource, (id: number) => string> = {
  photo: (id) => apiUrl(`/api/notice/catalog/image/${id}`),
  schematic: (id) => apiUrl(`/api/notice/catalog/schematic/${id}`),
  listing: (id) => apiUrl(`/api/notice/listing-image/${id}`),
};

// The bytes of one picture, whichever table it lives in. These endpoints already exist
// for the Parts database, so a run's thumbnail is the same URL the catalog uses and the
// browser has it cached.
export const pictureSrc = (ref: PictureRef) => SRC[ref.source](ref.imageId);

export const sameRef = (a: PictureRef | null, b: PictureRef) =>
  !!a && a.source === b.source && a.imageId === b.imageId;

// What to call a source on screen. A run row says which kind of picture it came from,
// and "listing" means nothing to a reader — "product photo" does.
export const SOURCE_LABEL: Record<PictureSource, string> = {
  photo: 'photograph',
  schematic: 'schematic',
  listing: 'product photo',
};
